<template>
	<div class="ui inline search compact dropdown manager-studio-picker">
		<input type="hidden" :value="studio" />
		<div class="text">All Studios</div>
		<i class="dropdown icon" />
		<div class="menu" style="z-index: 10000;">
			<div class="item" :data-value="studio.organizationId" v-for="studio in studios" :key="studio.organizationId">
				{{ studio.organizationName }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['schools', 'studio'],
	computed: {
		studios: function() {
			var studios = {};

			this.schools.forEach(function(job) {
				if(job.parentOrganizationId && !studios[job.parentOrganizationId]) {
					studios[job.parentOrganizationId] = {
						organizationId: job.parentOrganizationId,
						organizationName: job.parentOrganizationName
					};
				}
			});

			var studioList = Object.values(studios);
			studioList.sortByKey('organizationName');

			return $.merge([{
				organizationId: 'all studios',
				organizationName: 'All Studios'
			}], studioList);
		}
	},
	mounted: function() {
		var me = this;
		$(this.$el).dropdown({
			forceSelection: false,
			fullTextSearch: 'exact',
			match: 'text',
			onChange: function (value, text, elem) {
				if(value === 'all studios') {
					me.$emit('studioChanged', null);
				} else {
					me.$emit('studioChanged', value);
				}
			}
		});
	}
};
</script>

<style scoped>

</style>